<template>
  <div
    class="px-3"
    style="
      width: 100%;
      display: flex;
      height: unset !important;
      align-items: center;
    ">
    <v-select
      label="Condition Mode"
      class="mr-2"
      style="width: 150px; flex-grow: 0"
      v-model="userEditObj.conditions.mode"
      density="compact"
      :items="['All', 'Any']"></v-select>
    <div class="mx-2"></div>
    <v-select
      item-title="name"
      item-value="value"
      :hide-selected="false"
      label="Domination Mode"
      style="width: 150px; flex-grow: 0"
      v-model="userEditObj.domination_mode"
      :items="dominationModes"
      density="compact"
      filled
      :hint="domModeHint(dominationMode)"
      persistent-hint></v-select>
    <div class="mx-2"></div>
    <v-switch
      v-model="userEditObj.enabled"
      color="primary"
      label="Enabled"></v-switch>
    <div class="mx-2"></div>
    <v-spacer />
    <v-btn
      :disabled="!userEditObj.conditions_edited ? true : undefined"
      :color="userEditObj.conditions_edited ? 'primary' : undefined"
      @click="resetCondition()"
      variant="flat">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
  </div>
  <!-- add condition modal -->
  <ConditionPicker
    itemtype="scene"
    :item="userEditObj"
    :editable="true" />
</template>
<script setup>
import { deluge } from '../../../stores/deluge';
import { defineProps } from 'vue';
import ConditionPicker from '../../Shared/ConditionPicker.vue';
import { onBeforeMount, ref } from 'vue';
const props = defineProps(['userEditObj']);
const dominationModes = ref([
  { name: 'Disabled', value: 0 },
  { name: 'Interrupt', value: 1 },
  { name: 'Play Next', value: 2 },
]);
onBeforeMount(() => {
  if (!props.userEditObj.conditions?.mode) {
    props.userEditObj.conditions.mode = 'All';
  }
});
function domModeHint(dom) {
  if (dom === 0) {
    return 'Select a domination mode to enable';
  } else if (dom === 1) {
    return 'If conditions are valid, domination will interrupt current scene';
  } else if (dom === 2) {
    return 'If conditions are valid, domination will wait for current scene to end and then play';
  }
}
function resetCondition() {
  const template = deluge.templates[props.userEditObj.scene_name];
  if (template) {
    props.userEditObj.conditions = JSON.parse(
      JSON.stringify(template.conditions)
    );
  }
  props.userEditObj.conditions_edited = false;
}
</script>
